<template>
<div>
  <dd-text-box
      v-bind="computedProps"
      v-model="innerValue"
      v-on="computedListeners"
      >
    <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="isHelpDisplay">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                color="primary"
                v-bind="attrs"
                @click="onDialogButtonClick"
                v-on="on"
                tabindex="-1"
                dark
                elevation="0"
                small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
          </template>
          <span>受注契約検索用ポップアップを表示します</span>
        </v-tooltip>
      </v-btn>
    </template>
  </dd-text-box>
  <dd-juchu-keiyaku-kensaku-dialog
    :showDialog="showDialog"
    @close="onDialogClosed"/>
</div>
</template>
<script>
const DdTextBox = () => import('@/components/DdTextBox')
const DdJuchuKeiyakuKensakuDialog = () => import('@/components/DdJuchuKeiyakuKensakuDialog')

export default {
  name: 'DdJuchuKeiyakuKensakuTextBox',
  extends: DdTextBox,
  components: {
    DdTextBox,
    DdJuchuKeiyakuKensakuDialog
  },
  props: () => ({
    /**
     * readonly
     */
    readonly: Boolean,
    ref: {
      Type: String,
      default: 'jyuchuKeiyakuCd'
    }
  }),
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.juchuKeiyakuNo

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
    }
  }
}
</script>
<style scoped>
</style>
